import React from 'react';
import { useSelector } from 'react-redux';
import { usePlan } from "../../../../../contexts/PlanOperationContext/Plan";
import { aDayMillisecond } from '../../../../../util/varibles/constants';
import { getMondayByKey } from '../../../../../util/varibles/global';
import { IVessel } from '../../../../../util/varibles/interface';
import { LAYOUT_CALENDER, selectPlan } from "../../../constants";
import styles from "../style.module.scss";
import Day from './Day';

const week = [0, 1, 2, 3, 4, 5, 6];

interface IProps {
    vessels: IVessel[]
}

const Layout: React.FC<IProps> = ({ vessels }) => {
    const [isDrag] = usePlan(state => state.isDrag);
    const weeks = useSelector(selectPlan.weeks);

    return <div
        id={LAYOUT_CALENDER}
        className={styles['layout-calendar']}
        data-is-drag={isDrag}
    >
        <div className={styles.weeks}>
            {weeks.map(id => {
                const time = getMondayByKey(id).time;
                return <div id={id} key={id} className={styles.week}>
                    <div>
                        {vessels.map((item, i) => {
                            const { id } = item;
                            const styleDays = {
                                height: `calc(var(--${id}) + var(--more-height, 0px))`,
                                backgroundColor: 'transparent',
                            }
                            return <div key={i} className={styles.days} style={styleDays}>
                                {week.map((sub, subI) => <Day key={sub} time={time + (subI * aDayMillisecond)} vessel={item} />)}
                            </div>
                        })}
                    </div>
                </div>
            })}
        </div>
    </div >;
};

export default Layout;
